module.exports = __webpack_public_path__ + "static/media/BB.4a27edfc.png";